import { render } from "./distributor_staff.vue?vue&type=template&id=15759e1a"
import script from "./distributor_staff.vue?vue&type=script&lang=js"
export * from "./distributor_staff.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__